import React, { FC } from "react";
import classNames from "classnames/dedupe";
import { Typography } from "../../Fundamentals/Typography";
import { PlusIcon } from "../../../icons";
import { IBundlesButtonProps } from "./BundlesButton.interface";

const BundlesButton: FC<IBundlesButtonProps> = ({
  buttonText,
  title,
  disabled = false,
  isInvalid = false,
  errorMessage,
  ariaLabel,
  onClick,
}) => {
  const buttonClass = classNames("btn-bundles", { error: isInvalid });
  return (
    <div className="btn-bundles--wrapper">
      {title && (
        <Typography
          variant="text-bold"
          as="p"
          classes={{ root: "mb-6" }}
          data-testid="bundles-button-title"
        >
          {title}
        </Typography>
      )}
      <button
        type="button"
        className={buttonClass}
        onClick={onClick}
        aria-label={ariaLabel}
        data-testid="bundles-button"
        disabled={disabled}
      >
        <Typography variant="text-medium">{buttonText}</Typography>
        <div className="btn-bundles--icon">
          <PlusIcon />
        </div>
      </button>
      {isInvalid && !!errorMessage && (
        <div
          data-testid="bundles-button-errorMessage"
          className="invalid-feedback"
        >
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default BundlesButton;
